import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import IntlMessages from "../../../intl/IntlMessages";
import {
  FaBuilding,
  FaGraduationCap,
  FaChartLine,
  FaArrowRight,
  FaRegBuilding,
} from "react-icons/fa";
import "../Styles/Projets.css";
import { FiMessageSquare } from "react-icons/fi";

const Projets = () => {
  const solutions = [
    {
      id: 1,
      title: <IntlMessages id="solutions.realEstate" />,
      category: <IntlMessages id="expertise.realEstate" />,
      icon: <FaBuilding />,
      description: <IntlMessages id="solutions.completeManagement" />,
      features: [
        <IntlMessages id="solutions.propertySales" />,
        <IntlMessages id="solutions.propertyRentals" />,
        <IntlMessages id="solutions.propertyManagement" />,
        <IntlMessages id="solutions.appraisalValuation" />,
        <IntlMessages id="solutions.investmentConsulting" />,
        <IntlMessages id="solutions.newProjectsMarketing" />,
        <IntlMessages id="solutions.legalAssistance" />,
        <IntlMessages id="solutions.condominiumManagement" />,
        <IntlMessages id="solutions.propertyDevelopment" />,
        <IntlMessages id="solutions.mortgageConsulting" />,
        <IntlMessages id="solutions.buyerSellerSupport" />,
        <IntlMessages id="solutions.marketStudies" />,
        <IntlMessages id="solutions.relocationAssistance" />,
        <IntlMessages id="solutions.luxuryManagement" />,
        <IntlMessages id="solutions.wealthConsulting" />,
        <IntlMessages id="content.others" />,
      ],

      color: "#41B3A2",
      path: "/contact",
    },
    {
      id: 2,
      title: <IntlMessages id="eventManagement.title" />,
      category: <IntlMessages id="eventManagement.event" />,
      icon: <FaChartLine />,
      description: <IntlMessages id="solutions.eventManagement" />,
      features: [
        <IntlMessages id="content.event1" />,
        <IntlMessages id="content.event2" />,
        <IntlMessages id="content.event3" />,
        <IntlMessages id="content.event4" />,
        <IntlMessages id="content.event5" />,
        <IntlMessages id="content.event6" />,
        <IntlMessages id="content.event7" />,
        <IntlMessages id="content.event8" />,
        <IntlMessages id="content.event9" />,
        <IntlMessages id="content.event10" />,
        <IntlMessages id="content.event11" />,
        <IntlMessages id="content.event12" />,
        <IntlMessages id="content.event13" />,
        <IntlMessages id="content.event14" />,
        <IntlMessages id="content.event15" />,
        <IntlMessages id="content.others" />,
      ],
      color: "#c25744",
      path: "/contact",
    },
    {
      id: 3,
      title: <IntlMessages id="solutions.itServices" />,
      category: <IntlMessages id="solutions.it" />,
      icon: <FaGraduationCap />,
      description: <IntlMessages id="solutions.innovativeIT" />,
      features: [
        <IntlMessages id="content.software1" />,
        <IntlMessages id="content.software2" />,
        <IntlMessages id="content.software3" />,
        <IntlMessages id="content.software4" />,
        <IntlMessages id="content.software5" />,
        <IntlMessages id="content.it1" />,
        <IntlMessages id="content.it2" />,
        <IntlMessages id="content.it3" />,
        <IntlMessages id="content.it4" />,
        <IntlMessages id="content.it5" />,
        <IntlMessages id="content.av1" />,
        <IntlMessages id="content.av2" />,
        <IntlMessages id="content.av3" />,
        <IntlMessages id="content.av4" />,
        <IntlMessages id="content.av5" />,
        <IntlMessages id="content.design1" />,
        <IntlMessages id="content.design2" />,
        <IntlMessages id="content.design3" />,
        <IntlMessages id="content.design4" />,
        <IntlMessages id="content.design5" />,
        <IntlMessages id="content.network1" />,
        <IntlMessages id="content.network2" />,
        <IntlMessages id="content.network3" />,
        <IntlMessages id="content.network4" />,
        <IntlMessages id="content.network5" />,
      ],
      color: "#fcd362",
      path: "/contact",
    },
    {
      id: 4,
      title: <IntlMessages id="content.socialPlatform" />,
      category: <IntlMessages id="expertise.socialPlatform" />,
      icon: <FiMessageSquare />,
      description: <IntlMessages id="content.socialChatDescription" />,
      features: [
        <IntlMessages id="content.socialPlatform1" />,
        <IntlMessages id="content.socialPlatform2" />,
        <IntlMessages id="content.socialPlatform3" />,
        <IntlMessages id="content.socialPlatform4" />,
      ],
      color: "#47dde2",
      path: "/contact",
    },
    {
      id: 5,
      title: <IntlMessages id="content.btp" />,
      category: <IntlMessages id="content.btp" />,
      icon: <FaRegBuilding />,
      description: <IntlMessages id="content.civilDescription" />,
      features: [
        <IntlMessages id="content.civil1" />,
        <IntlMessages id="content.civil2" />,
        <IntlMessages id="content.civil3" />,
        <IntlMessages id="content.civil4" />,
        <IntlMessages id="content.civil5" />,
        <IntlMessages id="content.civil6" />,
        <IntlMessages id="content.civil7" />,
        <IntlMessages id="content.civil8" />,
        <IntlMessages id="content.civil9" />,
        <IntlMessages id="content.civil10" />,
      ],
      color: "#444342",
      path: "/contact",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  return (
    <section className="solutions-section">
      <div className="solutions-container">
        <motion.div
          className="solutions-header"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>
            <IntlMessages id="solutions.professional" />
          </h2>
          <div className="title-underline"></div>
          <p>
            <IntlMessages id="solutions.innovativeBusiness" />
          </p>
        </motion.div>

        <motion.div
          className="solutions-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {solutions.map((solution) => (
            <motion.div
              key={solution.id}
              className="solution-card"
              variants={cardVariants}
            >
              <div className="card-content">
                <div
                  className="solution-icon"
                  style={{ backgroundColor: solution.color }}
                >
                  {solution.icon}
                </div>
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
                <ul className="solution-features">
                  {solution.features.map((feature, index) => (
                    <li key={index}>
                      <span className="feature-bullet"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              <Link
                to={solution.path}
                className="solution-link"
                style={{ color: solution.color }}
              >
                <IntlMessages id="solutions.discover" />
                <FaArrowRight className="arrow-icon" />
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Projets;
